export default __webpack_public_path__ + "static/media/selectedHelpLogo.db8f168e.svg";